import React from 'react';
import './AiSection.css';

const AiSection = () => {
  const aiFeatures = [
    "Ethereum'un geleceği hakkında görüşler",
    "Uzun vadeli yatırım için uygun coinler",
    "DeFi platformları hakkında analizler",
    "Piyasa trendleri ve öngörüler",
    "Güncel kripto haberleri ve etkileri"
  ];

  return (
    <section id="ai" className="section ai-section">
      <div className="container">
        <div className="ai-grid">
          <div className="ai-content" data-aos="fade-right">
            <h2 className="section-title">
              <span className="gradient-text">CTO AI</span> ile Anında Uzman Yanıtları
            </h2>
            <p className="section-description">
              Kripto dünyasındaki her sorunuz için yapay zeka destekli CTO AI yanınızda. 
              Piyasa analizi, yatırım stratejileri ve kripto ekosistemi hakkında gerçek zamanlı 
              bilgiler alın.
            </p>
            
            <div className="ai-features">
              {aiFeatures.map((feature, index) => (
                <div 
                  className="ai-feature-item" 
                  key={index}
                  data-aos="fade-up" 
                  data-aos-delay={100 + (index * 100)}
                >
                  <div className="ai-feature-icon">✦</div>
                  <p>{feature}</p>
                </div>
              ))}
            </div>
            
            <a href="#download" className="btn" data-aos="fade-up">AI Asistanı Deneyin</a>
          </div>
          
          <div className="ai-image" data-aos="fade-left" data-aos-delay="200">
            <div className="ai-chat-container">
              <div className="ai-chat-header">
                <h3>Ask CTO AI Anything</h3>
              </div>
              <div className="ai-chat-messages">
                <div className="ai-message user">Ethereum'un geleceği hakkında ne düşünüyorsun?</div>
                <div className="ai-message bot">Ethereum, PoS geçişiyle birlikte enerji tüketimini %99.95 azalttı ve ölçeklenebilirliğini artırdı. Layer 2 çözümleriyle işlem kapasitesi artmaya devam edecek.</div>
                <div className="ai-message user">Hangi coinler uzun vadeli yatırım için uygun?</div>
                <div className="ai-message bot">Sağlam temelleri, geniş kullanım alanları ve sürekli gelişen ekosisteme sahip projeler genellikle uzun vadede daha stabil performans gösteriyor.</div>
              </div>
              <div className="ai-chat-input">
                <input type="text" placeholder="Sorunuzu yazın..." />
                <button>Gönder</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiSection; 